export const phaseList = [
  {
    id: 1,
    name: 'Guaranteed',
  },
  {
    id: 2,
    name: 'FCFS',
  },
  {
    id: 3,
    name: 'Public',
  },
];

